import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormView, DialogModal } from ".";
import { showDialog } from "../../appRedux/actions/common";
import { useNavigate } from "react-router-dom";
function AddInfo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));
  useEffect(() => {
    if (!dialog) {
      setOpen(dialog);
    }
  }, [dialog]);

  return (
    <Fragment>
      <button
        className="btn add-btn  m-r-5"
        onClick={() => {
          navigate("/course/create");
          // setOpen(true);
          // dispatch(showDialog({ title: "Add Course", size: "lg" }));
        }}
      >
        <i className="fa fa-plus" /> Add Course
      </button>
      {open && (
        <DialogModal bodyView={<FormView isUpdate={false} key={Math.random()} />}></DialogModal>
      )}
    </Fragment>
  );
}

export default AddInfo;
